module.exports = __webpack_public_path__ + "img/test_ava.83098a9c.png";